module.exports = __webpack_public_path__ + "static/media/sarcopenia-ai.9b3e2787.png";